import { render, staticRenderFns } from "./ZahnwerkstattStartPage.vue?vue&type=template&id=0636b5a4&scoped=true"
import script from "./ZahnwerkstattStartPage.vue?vue&type=script&lang=js"
export * from "./ZahnwerkstattStartPage.vue?vue&type=script&lang=js"
import style0 from "./ZahnwerkstattStartPage.vue?vue&type=style&index=0&id=0636b5a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0636b5a4",
  null
  
)

export default component.exports